import { useNavigationContext } from '~/Hooks';

export const useUnsavedChangesConfirmationModal = () => {
  // hooks
  const { blockNavigation, callback, isNavigationBlocked, isCallbackSet } = useNavigationContext();

  // handlers
  const onDiscard = () => {
    callback?.();
  };

  const onDismiss = () => {
    blockNavigation(false);
  };

  return {
    onDiscard,
    onDismiss,
    isConfirmationModalVisible: isCallbackSet && isNavigationBlocked,
  };
};
